import { FourHundredError, isBadRequestError } from "@repo/chameleon-request";
import { BagApiBadRequestError } from "../errors";

export const handleApiInteractionError = (error: unknown): never => {
  if (isBadRequestError(error)) {
    const badRequestError = error as FourHundredError;
    throw new BagApiBadRequestError(
      badRequestError.message,
      badRequestError.httpResponseBody,
    );
  }

  throw error;
};
